import React from "react";
import { useSelector } from "react-redux";
import { Item, MenuItem } from "../../../../components/Menu";
import { LanguageSwitcherSelectors } from "../../../../redux/selectors";
import { LocalizationMessages } from "../../../../localization/messages";
import { UrlUtils } from "../../../../utils";

export const BlogMenuItem = () => {
  const lang = useSelector(LanguageSwitcherSelectors.lang);

  const link = `https://www.888sport.com/${
    lang === "de" ? `${lang}/` : ""
  }blog/`;

  const blogItem = new Item({
    title: LocalizationMessages.blog,
    iconKey: "blog",
    URL: UrlUtils.getNativeLink(link),
    target: "_blank"
  });

  return (
    <MenuItem item={blogItem} dataTestId="uc-blog" ignoreNavigation={true} />
  );
};
